<template>
  <v-tooltip left content-class="tooltip" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="mr-4"> mdi-help-circle-outline </v-icon>
    </template>
    {{ hint }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'SearchInfo',
  props: {
    isInFulltextSearchMode: {
      type: Boolean,
    },
  },
  computed: {
    hint() {
      if (this.isInFulltextSearchMode) {
        return `${this.$t('search.fulltextSearch.hint1')} 
      ${this.$t('search.fulltextSearch.hint2')} 

      ${this.$t('search.fulltextSearch.hint3')} 
      
      ${this.$t('search.fulltextSearch.hint4')}`;
      } else {
        return this.$t('search.hint');
      }
    },
  },
};
</script>

<style scoped>
.tooltip {
  opacity: 1 !important;
  background: #202020;
  white-space: pre-line;
}
</style>
